import React from "react";
import ServiceHero from "../../components/ServiceHero";

const SEOHome = () => (
  <ServiceHero
    eyebrow="Search Engine Optimization"
    title="Be found when it"
    highlight="matters most."
    description="We combine technical SEO, search-led content, and authority building to help the right customers discover your business—and keep finding it over time."
    features={[
      "Technical and on-page SEO",
      "Intent-led keyword strategy",
      "Sustainable organic growth",
    ]}
    image="/Images/seo.png"
    imageAlt="Illustration of search engine optimization and website discovery"
    visualLabel="Visibility with lasting value"
    visualTitle="Move from buried in search to present at the right moment."
  />
);

export default SEOHome;
